import getRecordSelector from 'root/src/client/logic/api/selectors/getRecordSelector'
import equals from 'ramda/src/equals'
import any from 'ramda/src/any'
import { GET_PROJECT } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { getResponseLenses } from 'root/src/shared/descriptions/getEndpointDesc'
import { pledgeAmountProp } from 'root/src/shared/util/commonLenses'
import {
	projectAcceptedKey, projectDeliveryPendingKey, projectDeliveredKey,
} from 'root/src/shared/constants/keys'
import goalAmountSelector from 'root/src/client/logic/project/selectors/goalAmountSelector'

const responseLenses = getResponseLenses(GET_PROJECT)
const {
	viewStatus,
} = responseLenses

export default (state, props) => {
	const record = getRecordSelector(state, props)
	const equalsStatus = equals(viewStatus(record))
	const accepted = any(equalsStatus)([
		projectAcceptedKey, projectDeliveryPendingKey, projectDeliveredKey,
	])

	if (accepted) {
		const goalAmount = goalAmountSelector(state, props)
		if (equals(goalAmount, 0)) {
			return 5
		}
		const pledgeAmount = pledgeAmountProp(record)
		const answer = pledgeAmount / goalAmount * 100
		// eslint-disable-next-line no-nested-ternary
		return answer < 5 ? 5 : answer > 100 ? 100 : answer
	}
	return 5
}
